import { createAction, props } from '@ngrx/store';
import { HttpError } from '@rd/types';
import { UserFlagModel } from '@rd/types/user-flag.model';

export const LoadUserFlags = createAction('[UserFlags] Load User Flags');

export const LoadUserFlagsSuccess = createAction(
  '[UserFlags] Load User Flags Success',
  props<{ payload: UserFlagModel[] }>(),
);

export const LoadUserFlagsFail = createAction(
  '[UserFlags] Load User Flags Fail',
  props<{ payload: HttpError }>(),
);
